<script>
import MultiSelect from "primevue/multiselect";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { ref, computed } from "vue";
export default {
  components: {
    MultiSelect,
  },
  data() {
    return {
      isFieldsetVisible: true,
      isOneFieldsetVisible: false,
      isSecondFieldsetVisible: false,
      isThirdFieldsetVisible: false,
      isFourFieldsetVisible: false,
      editor: ClassicEditor,
      editorData: "Description",
      editorConfig: {},
      faqs: [{ question: "", answer: "" }],
      titles: [{ title: "" }],
      services: [{ name: "", price: "", duration: "" }],
      BraxSelecOne: ["Select", "London", "Paris"],
      BraxSelec: ["Select", "Brazil", "Canda"],
      PreceHousTwo: ["Select", "Minutes", "Minutes"],
      PreceHousOne: ["Select", "Percentage", "Price"],
      PreceHous: ["Select", "Percentage", "Price"],
      CreateHousOne: ["Select", "Car Wash", "House Cleaning"],
      CreateHous: ["Select", "Car Wash", "House Cleaning"],
      Darleeid: ["Darlee Robertson", "Sharon Roy", "Vaughan", "Jessica", "Carol Thomas"],
      title: "Create a Service",
      text: "Service",
      text1: "Create a Service",
      images: [
        require("@/assets/img/gallery/gallery-01.jpg"),
        require("@/assets/img/gallery/gallery-02.jpg"),
        require("@/assets/img/gallery/gallery-03.jpg"),
        require("@/assets/img/gallery/gallery-04.jpg"),
        require("@/assets/img/gallery/gallery-05.jpg"),
      ],
      avatars: [require("@/assets/img/gallery/gallery-03.jpg")],
    };
  },
  methods: {
    removeImage(index) {
      // Remove the image from the array at the specified index
      this.images.splice(index, 1);
    },
    removeAvatar(index) {
      this.avatars.splice(index, 1);
    },
    addImage(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.images.push(e.target.result); // Add new image to the array
        };
        reader.readAsDataURL(file); // Read the file as a data URL
      }
    },
    submitForm() {
      this.$router.push("/service/create-service");
    },
    addTitle() {
      this.titles.push({ title: "" }); // Add a new title input
    },
    removeTitle(index) {
      this.titles.splice(index, 1); // Remove title input at the specified index
    },
    addService() {
      this.services.push({ name: "", price: "", duration: "" }); // Add a new service input
    },
    removeService(index) {
      this.services.splice(index, 1); // Remove service input at the specified index
    },
    addFaq() {
      this.faqs.push({ question: "", answer: "" }); // Add a new FAQ entry
    },
    removeFaq(index) {
      this.faqs.splice(index, 1); // Remove FAQ entry at the specified index
    },
    showOneFieldset() {
      this.isFieldsetVisible = false;
      this.isOneFieldsetVisible = true;

      // Hide the first fieldset
      const firstFieldset = document.getElementById("first-field");
      if (firstFieldset) {
        firstFieldset.style.display = "none";
      }
    },
    showSecondFieldset() {
      this.isOneFieldsetVisible = false;
      this.isSecondFieldsetVisible = true;

      // Hide the first fieldset
      const secondFieldset = document.getElementById("second-field");
      if (secondFieldset) {
        secondFieldset.style.display = "none";
      }
    },
    showThirdFieldset() {
      this.isSecondFieldsetVisible = false;
      this.isThirdFieldsetVisible = true;

      // Hide the first fieldset
      const thirdFieldset = document.getElementById("third-field");
      if (thirdFieldset) {
        thirdFieldset.style.display = "none";
      }
    },
    showFourFieldset() {
      this.isThirdFieldsetVisible = false;
      this.isFourFieldsetVisible = true;

      // Hide the first fieldset
      const fourFieldset = document.getElementById("four-field");
      if (fourFieldset) {
        fourFieldset.style.display = "none";
      }
    },
    hideFieldset() {
      this.isFieldsetVisible = true;
      this.isOneFieldsetVisible = false;

      // Show the first fieldset
      const firstFieldset = document.getElementById("first-field");
      if (firstFieldset) {
        firstFieldset.style.display = "flex";
      }
    },
    hideSecondFieldset() {
      this.isOneFieldsetVisible = true;
      this.isSecondFieldsetVisible = false;

      // Show the first fieldset
      const secondFieldset = document.getElementById("second-field");
      if (secondFieldset) {
        secondFieldset.style.display = "flex";
      }
    },
    hideThirdFieldset() {
      this.isSecondFieldsetVisible = true;
      this.isThirdFieldsetVisible = false;

      // Show the first fieldset
      const thirdFieldset = document.getElementById("third-field");
      if (thirdFieldset) {
        thirdFieldset.style.display = "flex";
      }
    },
    hideFourFieldset() {
      this.isThirdFieldsetVisible = true;
      this.isFourFieldsetVisible = false;

      // Show the first fieldset
      const fourFieldset = document.getElementById("four-field");
      if (fourFieldset) {
        fourFieldset.style.display = "flex";
      }
    },
  },
};
</script>
<template>
  <layout-header></layout-header>
  <page-breadcrumb :title="title" :text="text" :text1="text1" />
  <div class="page-wrapper">
    <div class="content content-two">
      <div class="container">
        <div class="row">
          <div class="col-lg-9">
            <div class="service-wizard mb-4">
              <ul class="d-flex align-items-center flex-wrap row-gap-2" id="progressbar">
                <li :class="{ active: isFieldsetVisible }" class="me-2">
                  <span class="me-2"><i class="ti ti-info-circle"></i></span>
                  <h6>Service Information</h6>
                </li>
                <li :class="{ active: isOneFieldsetVisible }" class="me-2">
                  <span class="me-2"><i class="ti ti-map-pin"></i></span>
                  <h6>Location</h6>
                </li>
                <li :class="{ active: isSecondFieldsetVisible }" class="me-2">
                  <span class="me-2"><i class="ti ti-photo"></i></span>
                  <h6>Gallery</h6>
                </li>
                <li :class="{ active: isThirdFieldsetVisible }" class="me-2">
                  <span class="me-2"><i class="ti ti-message-question"></i></span>
                  <h6>FAQ</h6>
                </li>
                <li :class="{ active: isFourFieldsetVisible }" class="me-2">
                  <span class="me-2"><i class="ti ti-shield"></i></span>
                  <h6>SEO</h6>
                </li>
              </ul>
            </div>
            <div class="service-inform-fieldset">
              <fieldset
                id="first-field"
                :style="{ display: isFieldsetVisible ? 'flex' : 'none' }"
              >
                <h4 class="mb-3">Service Information</h4>
                <form @submit.prevent="submitForm">
                  <div class="card">
                    <div class="card-body">
                      <div class="accordion" id="accordionPanelsStayOpenExample">
                        <div class="accordion-item mb-3">
                          <div class="accordion-header" id="accordion-headingOne">
                            <div
                              class="accordion-button p-0"
                              data-bs-toggle="collapse"
                              data-bs-target="#accordion-collapseOne"
                              aria-expanded="true"
                              aria-controls="accordion-collapseOne"
                              role="button"
                            >
                              Basic Information
                            </div>
                          </div>
                          <div
                            id="accordion-collapseOne"
                            class="accordion-collapse collapse show"
                            aria-labelledby="accordion-headingOne"
                          >
                            <div class="accordion-body p-0 mt-3 pb-1">
                              <div class="row">
                                <div class="col-md-6">
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >Service Title
                                      <span class="text-danger">*</span></label
                                    >
                                    <input type="text" class="form-control" />
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >Slug <span class="text-danger">*</span></label
                                    >
                                    <input type="text" class="form-control" />
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >Category <span class="text-danger">*</span></label
                                    >
                                    <vue-select
                                      :options="CreateHous"
                                      id="createhous"
                                      placeholder="Select"
                                    />
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >Sub Category
                                      <span class="text-danger">*</span></label
                                    >
                                    <vue-select
                                      :options="CreateHousOne"
                                      id="createhousone"
                                      placeholder="Select"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item mb-3">
                          <div class="accordion-header" id="accordion-headingTwo">
                            <div
                              class="accordion-button p-0"
                              data-bs-toggle="collapse"
                              data-bs-target="#accordion-collapseTwo"
                              aria-expanded="true"
                              aria-controls="accordion-collapseTwo"
                            >
                              Pricing
                              <div class="form-check form-switch ms-3">
                                <input class="form-check-input" type="checkbox" />
                                <label class="form-check-label">Free</label>
                              </div>
                            </div>
                          </div>
                          <div
                            id="accordion-collapseTwo"
                            class="accordion-collapse collapse show"
                            aria-labelledby="accordion-headingTwo"
                          >
                            <div class="accordion-body p-0 mt-3 pb-1">
                              <div class="row">
                                <div class="col-xl-3 col-md-6">
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >Enter Amount
                                      <span class="text-danger">*</span></label
                                    >
                                    <input type="text" class="form-control" />
                                  </div>
                                </div>
                                <div class="col-xl-3 col-md-6">
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >Offer Price
                                      <span class="text-danger">*</span></label
                                    >
                                    <vue-select
                                      :options="PreceHous"
                                      id="precehous"
                                      placeholder="Select"
                                    />
                                  </div>
                                </div>
                                <div class="col-xl-3 col-md-6">
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >Price after discount
                                      <span class="text-danger">*</span></label
                                    >
                                    <input type="text" class="form-control" disabled />
                                  </div>
                                </div>
                                <div class="col-xl-3 col-md-6">
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >Tax <span class="text-danger">*</span></label
                                    >
                                    <vue-select
                                      :options="PreceHousOne"
                                      id="precehousone"
                                      placeholder="Select"
                                    />
                                  </div>
                                </div>
                                <div class="col-xl-3 col-md-6">
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >Duration <span class="text-danger">*</span></label
                                    >
                                    <vue-select
                                      :options="PreceHousTwo"
                                      id="precehousTwo"
                                      placeholder="Select"
                                    />
                                  </div>
                                </div>
                                <div class="col-md-12">
                                  <div class="form-check mb-3">
                                    <input
                                      class="form-check-input"
                                      type="radio"
                                      name="flexRadioDefault"
                                      id="zoom_meet"
                                      checked
                                    />
                                    <label class="form-check-label" for="zoom_meet">
                                      Allow Zoom Meeting
                                    </label>
                                  </div>
                                </div>
                                <div class="col-md-12">
                                  <div class="mb-3 zoom-meet-link">
                                    <label class="form-label">Zoom Invitation Link</label>
                                    <input type="text" class="form-control" />
                                  </div>
                                </div>
                                <div class="col-md-12">
                                  <div class="form-check mb-3">
                                    <input
                                      class="form-check-input"
                                      type="radio"
                                      name="flexRadioDefault"
                                      id="google_meet"
                                    />
                                    <label class="form-check-label" for="google_meet">
                                      Allow Google Meet
                                    </label>
                                  </div>
                                </div>
                                <div class="col-md-12">
                                  <div class="mb-3 google-meet-link">
                                    <label class="form-label"
                                      >Google Invitation Link</label
                                    >
                                    <input type="text" class="form-control" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item mb-3">
                          <div class="accordion-header" id="accordion-headingThree">
                            <div
                              class="accordion-button p-0"
                              data-bs-toggle="collapse"
                              data-bs-target="#accordion-collapseThree"
                              aria-expanded="true"
                              aria-controls="accordion-collapseThree"
                              role="button"
                            >
                              Location & Staffs
                              <span class="fs-14 ms-1 text-default"
                                >( Can add multiple Locations )</span
                              >
                            </div>
                          </div>
                          <div
                            id="accordion-collapseThree"
                            class="accordion-collapse collapse show"
                            aria-labelledby="accordion-headingThree"
                          >
                            <div class="accordion-body p-0 mt-3 pb-1">
                              <div class="row">
                                <div class="col-md-12">
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >Staff <span class="text-danger"> *</span></label
                                    >
                                    <vue-select
                                      :options="Darleeid"
                                      id="darleeid"
                                      placeholder="Darlee Robertson"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item mb-3">
                          <div class="accordion-header" id="accordion-headingFour">
                            <div
                              class="accordion-button p-0"
                              data-bs-toggle="collapse"
                              data-bs-target="#accordion-collapseFour"
                              aria-expanded="true"
                              aria-controls="accordion-collapseFour"
                              role="button"
                            >
                              Includes
                            </div>
                          </div>
                          <div
                            id="accordion-collapseFour"
                            class="accordion-collapse collapse show"
                            aria-labelledby="accordion-headingFour"
                          >
                            <div class="accordion-body p-0 mt-3 pb-1">
                              <div class="addtitle-info">
                                <div class="row">
                                  <div
                                    class="col-md-12"
                                    v-for="(item, index) in titles"
                                    :key="index"
                                  >
                                    <div class="mb-3">
                                      <label class="form-label"
                                        >Title <span class="text-danger"> *</span></label
                                      >
                                      <div class="d-flex align-items-center">
                                        <input
                                          type="text"
                                          class="form-control"
                                          v-model="item.title"
                                        />
                                        <!-- Show delete button only for subsequent items -->
                                        <a
                                          v-if="index > 0"
                                          href="#"
                                          class="text-primary d-inline-flex align-items-center text-danger delete-item ms-4"
                                          @click.prevent="removeTitle(index)"
                                        >
                                          <i class="ti ti-trash"></i>
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <a
                                href="javascript:void(0);"
                                class="text-primary d-inline-flex align-items-center add-extra fs-14 mb-3"
                                @click.prevent="addTitle"
                              >
                                <i class="ti ti-circle-plus me-2"></i>Add New
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item mb-3">
                          <div class="accordion-header" id="accordion-headingFive">
                            <div
                              class="accordion-button p-0"
                              data-bs-toggle="collapse"
                              data-bs-target="#accordion-collapseFive"
                              aria-expanded="true"
                              aria-controls="accordion-collapseFive"
                              role="button"
                            >
                              Add Additional Services
                            </div>
                          </div>
                          <div
                            id="accordion-collapseFive"
                            class="accordion-collapse collapse show"
                            aria-labelledby="accordion-headingFive"
                          >
                            <div class="accordion-body p-0 mt-3 pb-1">
                              <div class="addservice-info">
                                <div
                                  class="row"
                                  v-for="(service, index) in services"
                                  :key="index"
                                >
                                  <div class="col-xl-5">
                                    <div class="d-flex align-items-center mb-3">
                                      <div
                                        class="file-upload service-file-upload d-flex align-items-center justify-content-center flex-column me-4"
                                      >
                                        <i class="ti ti-photo"></i>
                                        <input type="file" accept="video/image" />
                                      </div>
                                      <div class="mb-3 flex-fill">
                                        <label class="form-label"
                                          >Name <span class="text-danger"> *</span></label
                                        >
                                        <input
                                          type="text"
                                          class="form-control"
                                          v-model="service.name"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-xl-3">
                                    <div class="mb-3">
                                      <label class="form-label"
                                        >Price <span class="text-danger"> *</span></label
                                      >
                                      <input
                                        type="text"
                                        class="form-control"
                                        v-model="service.price"
                                      />
                                    </div>
                                  </div>
                                  <div class="col-xl-4">
                                    <div class="mb-3">
                                      <label class="form-label"
                                        >Duration
                                        <span class="text-danger"> *</span></label
                                      >
                                      <div class="d-flex align-items-center">
                                        <input
                                          type="text"
                                          class="form-control"
                                          v-model="service.duration"
                                        />
                                        <!-- Show delete button only for subsequent items -->
                                        <a
                                          v-if="index > 0"
                                          href="javascript:void(0);"
                                          class="text-primary d-inline-flex align-items-center text-danger delete-item ms-4"
                                          @click.prevent="removeService(index)"
                                        >
                                          <i class="ti ti-trash"></i>
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <a
                                href="javascript:void(0);"
                                class="text-primary d-inline-flex align-items-center fs-14 add-extra2 mb-3"
                                @click.prevent="addService"
                              >
                                <i class="ti ti-circle-plus me-2"></i>Add New
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item mb-3">
                          <div class="accordion-header" id="accordion-headingSix">
                            <div
                              class="accordion-button p-0"
                              data-bs-toggle="collapse"
                              data-bs-target="#accordion-collapseSix"
                              aria-expanded="true"
                              aria-controls="accordion-collapseSix"
                              role="button"
                            >
                              Service Overview
                            </div>
                          </div>
                          <div
                            id="accordion-collapseSix"
                            class="accordion-collapse collapse show"
                            aria-labelledby="accordion-headingSix"
                          >
                            <div class="accordion-body p-0 mt-3 pb-1">
                              <div class="row">
                                <div class="col-md-12">
                                  <div class="mb-3">
                                    <label class="form-label">Overview</label>
                                    <ckeditor
                                      :editor="editor"
                                      v-model="editorData"
                                      class="form-control ck-editor"
                                      :config="editorConfig"
                                    ></ckeditor>
                                  </div>
                                </div>
                                <div class="col-md-12">
                                  <div class="mb-3">
                                    <label class="form-label"
                                      >Service Status
                                      <span class="text-danger"> *</span></label
                                    >
                                    <div class="d-flex align-items-center mb-3">
                                      <div class="form-check me-3">
                                        <input
                                          class="form-check-input"
                                          type="radio"
                                          name="status"
                                          id="status_active"
                                          checked=""
                                        />
                                        <label
                                          class="form-check-label"
                                          for="status_active"
                                        >
                                          Active
                                        </label>
                                      </div>
                                      <div class="form-check">
                                        <input
                                          class="form-check-input"
                                          type="radio"
                                          name="status"
                                          id="status_inactive"
                                        />
                                        <label
                                          class="form-check-label"
                                          for="status_inactive"
                                        >
                                          Inactive
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="text-end">
                        <button
                          class="btn btn-dark next_btn"
                          @click="showOneFieldset"
                          type="button"
                        >
                          Continue
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </fieldset>
              <fieldset :style="{ display: isOneFieldsetVisible ? 'flex' : 'none' }">
                <h4 class="mb-3">Location</h4>
                <form @submit.prevent="submitForm">
                  <div class="card">
                    <div class="card-body">
                      <div class="border-bottom mb-3 pb-3">
                        <h4 class="fs-20">Add Location</h4>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="mb-3">
                            <label class="form-label">Address <span> *</span></label>
                            <input type="text" class="form-control" />
                          </div>
                        </div>
                        <div class="col-xl-4 col-lg-6">
                          <div class="mb-3">
                            <label class="form-label"
                              >Country <span class="text-danger">*</span></label
                            >
                            <vue-select
                              :options="BraxSelec"
                              id="braxselec"
                              placeholder="Select"
                            />
                          </div>
                        </div>
                        <div class="col-xl-4 col-lg-6">
                          <div class="mb-3">
                            <label class="form-label"
                              >City <span class="text-danger">*</span></label
                            >
                            <vue-select
                              :options="BraxSelecOne"
                              id="braxselecone"
                              placeholder="Select"
                            />
                          </div>
                        </div>
                        <div class="col-xl-4 col-lg-6">
                          <div class="mb-3">
                            <label class="form-label"
                              >State <span class="text-danger">*</span></label
                            >
                            <input type="text" class="form-control" />
                          </div>
                        </div>
                        <div class="col-xl-4 col-lg-6">
                          <div class="mb-3">
                            <label class="form-label"
                              >Pincode <span class="text-danger">*</span></label
                            >
                            <input type="text" class="form-control" />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="border-bottom mb-3 pb-3">
                            <div class="map-grid mb-0">
                              <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6509170.989457427!2d-123.80081967108484!3d37.192957227641294!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb9fe5f285e3d%3A0x8b5109a227086f55!2sCalifornia%2C%20USA!5e0!3m2!1sen!2sin!4v1669181581381!5m2!1sen!2sin"
                                allowfullscreen=""
                                aria-hidden="false"
                                tabindex="0"
                                class="contact-map w-100"
                              ></iframe>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex align-items-center justify-content-end">
                        <button
                          type="button"
                          class="btn btn-light prev_btn me-3"
                          @click="hideFieldset"
                        >
                          Back
                        </button>
                        <button
                          type="button"
                          class="btn btn-dark next_btn"
                          @click="showSecondFieldset"
                        >
                          Save & Continue
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </fieldset>
              <fieldset :style="{ display: isSecondFieldsetVisible ? 'flex' : 'none' }">
                <h4 class="mb-3">Gallery</h4>
                <form @submit.prevent="submitForm">
                  <div class="card">
                    <div class="card-body">
                      <div class="border-bottom mb-3 pb-3">
                        <h4 class="fs-20">Add Media & Files</h4>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="mb-3">
                            <label class="form-label">
                              Add Service Images <span class="text-danger"> *</span>
                            </label>
                            <div class="d-flex align-items-center flex-wrap row-gap-3">
                              <!-- Loop through the images array -->
                              <div
                                class="avatar avatar-gallery me-3"
                                v-for="(image, index) in images"
                                :key="index"
                              >
                                <img :src="image" alt="Img" />
                                <a
                                  href="javascript:void(0);"
                                  class="trash-top d-flex align-items-center justify-content-center"
                                  @click.prevent="removeImage(index)"
                                >
                                  <i class="ti ti-trash"></i>
                                </a>
                              </div>
                              <div
                                class="file-upload d-flex align-items-center justify-content-center flex-column"
                              >
                                <i class="ti ti-photo mb-2"></i>
                                <p class="mb-0">Add Images</p>
                                <input type="file" accept="image/*" @change="addImage" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="mb-3">
                            <label class="form-label">Service Video</label>
                            <div
                              class="file-upload drag-file w-100 d-flex align-items-center justify-content-center flex-column mb-2"
                            >
                              <span class="upload-img d-block mb-2"
                                ><img src="@/assets/img/icons/upload-icon.svg" alt="Img"
                              /></span>
                              <p class="mb-0">
                                Drag & Drop or <span class="text-primary"> Browse</span>
                              </p>
                              <input type="file" accept="video/image" />
                            </div>
                            <div
                              v-for="(avatar, index) in avatars"
                              :key="index"
                              class="avatar avatar-gallery me-3"
                            >
                              <img :src="avatar" alt="Img" />
                              <a
                                href="javascript:void(0);"
                                class="trash-top d-flex align-items-center justify-content-center"
                                @click="removeAvatar(index)"
                              >
                                <i class="ti ti-trash"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="mb-3">
                            <label class="form-label">Video Link</label>
                            <input type="text" class="form-control" />
                          </div>
                        </div>
                      </div>
                      <div
                        class="d-flex align-items-center justify-content-end border-top pt-3"
                      >
                        <button
                          type="button"
                          class="btn btn-light prev_btn me-3"
                          @click="hideSecondFieldset"
                        >
                          Back
                        </button>
                        <button
                          type="button"
                          class="btn btn-dark next_btn"
                          @click="showThirdFieldset"
                        >
                          Save & Continue
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </fieldset>
              <fieldset :style="{ display: isThirdFieldsetVisible ? 'flex' : 'none' }">
                <h4 class="mb-3">FAQ</h4>
                <form @submit.prevent="submitForm">
                  <div class="card">
                    <div class="card-body">
                      <div class="add-faq-info">
                        <div class="row" v-for="(faq, index) in faqs" :key="index">
                          <div class="col-md-6">
                            <div class="mb-3">
                              <label class="form-label">Question </label>
                              <input
                                type="text"
                                class="form-control"
                                v-model="faq.question"
                              />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="mb-3">
                              <label class="form-label">Answer </label>
                              <div class="d-flex align-items-center">
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="faq.answer"
                                />
                                <!-- Show delete button only for subsequent entries -->
                                <a
                                  v-if="index > 0"
                                  href="javascript:void(0);"
                                  class="text-primary d-inline-flex align-items-center text-danger delete-item ms-4"
                                  @click.prevent="removeFaq(index)"
                                >
                                  <i class="ti ti-trash"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <a
                          href="javascript:void(0);"
                          class="text-primary d-inline-flex align-items-center fs-14 add-extra-faq mb-3"
                          @click.prevent="addFaq"
                        >
                          <i class="ti ti-circle-plus me-2"></i>Add New
                        </a>
                        <div
                          class="d-flex align-items-center justify-content-end border-top pt-3"
                        >
                          <button
                            type="button"
                            class="btn btn-light prev_btn me-3"
                            @click="hideThirdFieldset"
                          >
                            Back
                          </button>
                          <button
                            type="button"
                            class="btn btn-dark next_btn"
                            @click="showFourFieldset"
                          >
                            Save & Continue
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </fieldset>
              <fieldset :style="{ display: isFourFieldsetVisible ? 'flex' : 'none' }">
                <h4 class="mb-3">Seo</h4>
                <form @submit.prevent="submitForm">
                  <div class="card">
                    <div class="card-body">
                      <div class="border-bottom mb-3 pb-3">
                        <h4 class="fs-20">Seo Details</h4>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="mb-3">
                            <label class="form-label"
                              >Meta Title <span class="text-danger"> *</span>
                            </label>
                            <input type="text" class="form-control" />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="mb-3">
                            <label class="form-label"
                              >Meta Keywords <span class="text-danger"> *</span></label
                            >
                            <input type="text" class="form-control" />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="mb-3">
                            <label class="form-label"
                              >Meta Description <span class="text-danger"> *</span></label
                            >
                            <input type="text" class="form-control" />
                          </div>
                        </div>
                      </div>
                      <div
                        class="d-flex align-items-center justify-content-end border-top pt-3"
                      >
                        <button
                          type="button"
                          class="btn btn-light prev_btn me-3"
                          @click="hideFourFieldset"
                        >
                          Back
                        </button>
                        <button
                          type="button"
                          class="btn btn-dark"
                          data-bs-toggle="modal"
                          data-bs-target="#successmodal"
                        >
                          Save & Continue
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </fieldset>
            </div>
          </div>
          <div class="col-lg-3">
            <div>
              <div class="text-end mb-4">
                <a href="javascript:void(0);" class="btn btn-light"
                  ><i class="ti ti-eye me-2"></i>Live Preview</a
                >
              </div>
              <h4 class="mb-4">Quick Preview</h4>
            </div>
            <div class="service-item">
              <div class="service-img">
                <div class="slide-images">
                  <router-link to="/service-details">
                    <img
                      src="@/assets/img/services/service-27.jpg"
                      class="img-fluid"
                      alt="img"
                    />
                  </router-link>
                </div>
                <span class="trend-tag">Car Wash</span>
              </div>
              <div class="service-content">
                <h6 class="text-truncate mb-1">
                  <router-link to="/service-details">Electrical Services</router-link>
                </h6>
                <p class="fw-medium fs-14 mb-3">
                  <i class="ti ti-map-pin me-1"></i>Montana, USA
                </p>
                <p class="service-price">
                  $20.00 <span class="text-decoration-line-through">$25.00 </span
                  ><span> /hr</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <create-services-modal></create-services-modal>
</template>
